import { Button, Checkbox, Field, Input } from '@itds/elements/index.js';
import React, { useContext, useState } from 'react';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import Api from '@carrier/utils/Api';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import PropTypes from 'prop-types';

const General = ({ loadDataVersion, version }) => {
  const { setNotification } = useContext(CarrierContext);
  const [data, setData] = useState({
    api_token: version.api_token || '',
    api_url: version.api_url || '',
    beta: version.beta,
    date_gone_beta: version.date_gone_beta,
    date_gone_live: version.date_gone_live,
    hide_premium_breakdown: version.hide_premium_breakdown,
    live: version.live,
    name: version.name || '',
    notes: version.notes || ''
  });
  const [saving, setSaving] = useState(false);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleSave = () => {
    setSaving(true);
    Api.updateDataVersion(version.id, data).then(() => {
      loadDataVersion();
      setSaving(false);
      setNotification(ACTION_MESSAGES.CARRIERS.LIFE_QUOTE.SAVE);
    });
  };

  return (
    <>
      <Field label='Name'>
        <Input onChange={handleInputChange.bind(null, 'name')} value={data.name} />
      </Field>

      <Field label='API URL'>
        <Input onChange={handleInputChange.bind(null, 'api_url')} value={data.api_url} />
      </Field>

      <Field label='API Token'>
        <Input onChange={handleInputChange.bind(null, 'api_token')} value={data.api_token} />
      </Field>

      <Field label='Internal Notes'>
        <Input
          height={150}
          onChange={handleInputChange.bind(null, 'notes')}
          type='textarea'
          value={data.notes}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.hide_premium_breakdown}
          label='Hide premium breakdown in UI'
          onChange={handleCheckboxChange.bind(null, 'hide_premium_breakdown')}
        />
      </Field>

      <Button
        disabled={saving}
        icon={saving ? 'loading mdi-spin' : null}
        inline={true}
        onClick={handleSave}
      >
        {saving ? 'Saving...' : 'Save Changes'}
      </Button>
    </>
  );
};

General.propTypes = { loadDataVersion: PropTypes.func, version: PropTypes.object };

export default General;
